import { render, staticRenderFns } from "./TheGallery.component.vue?vue&type=template&id=5fc32292"
import script from "./TheGallery.component.vue?vue&type=script&lang=js"
export * from "./TheGallery.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports